import React from "react";
import Tooltip from "@mui/material/Tooltip";
import {modalSideService} from "../../../services/modalSideService";
import {Colors} from "../../../assets/colors/Colors";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {validObjectKeys} from "../../../util/functions";
import {ModalSide} from "../../../components/ModalSide";

const ViewDetailErrorsProductsVirtuals = ({properties}) => {

  const {data, descripcion, title} = properties;

  return(
    <div className="p-2">

      <div className="mb-3 d-flex align-items-center justify-content-end">

        <Tooltip title="Cerrar" aria-label="cerrar">
          <a onClick={() => modalSideService.clear("modalDetailErroresProductosVirtuales")} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <p className="mb-0 text-justify">{descripcion}</p>

      <p className="font-weight-bold mt-2">{title}</p>


      <div className="px-0 col-12">

        {
          Object.keys(data)?.map((key, index) => (
            <div className="my-1" key={`key${data[key]}${index}`} >
              <div className="d-flex align-items-center justify-content-between p-1">

                <div className="d-flex align-items-center">
                  <Tooltip title={data[key]?.msg || ""}>
                    <i className="fas fa-info-circle fa-lg cursor-pointer" style={{color: Colors.COLOR_BLUE_THEME}}/>
                  </Tooltip>

                  <div className="d-flex align-items-center mx-2">
                    {key} - {data[key]?.msg || "Error general de estructura"}
                  </div>
                </div>

              </div>
            </div>
          ))
        }

      </div>

    </div>

  )

}

export default ViewDetailErrorsProductsVirtuals;
